import React from 'react';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import CardIcon from './card_icon';

const styles = {
    main: {
        flex: '1',
        marginRight: '1em',
        marginTop: 30,
        cursor: 'pointer'
    },
    card: {
        overflow: 'inherit',
        textAlign: 'right',
        padding: 16,
        minHeight: 52,
        minWidth: 240
    },
};

const CountCard = ({ value, classes, title, icon, bgColor, onClick }) => (
    <div className={classes.main} onClick={onClick}>
        <CardIcon Icon={icon} bgColor={bgColor} />
        <Card className={classes.card}>
            <Typography className={classes.title} color="textSecondary">
                {title}
            </Typography>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                {value}
            </Typography>
        </Card>
    </div>
);

export default withStyles(styles)(CountCard);